/** Umut Demir has its own small motion module so its animation can evolve independently. */
export async function mountUmutDemirAnimation(host: HTMLElement): Promise<() => void> {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return () => undefined;
  const { gsap } = await import('gsap');
  const context = gsap.context(() => {
    gsap.from(host.querySelectorAll('.service-hero .hero-copy>*'), { autoAlpha: 0, y: 24, stagger: .08, duration: .7, ease: 'power3.out' });
    gsap.from(host.querySelectorAll('.showcase-block'), { autoAlpha: 0, y: 26, stagger: .1, duration: .7, ease: 'power3.out', delay: .15 });
  }, host);
  return () => context.revert();
}
